import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100 bg-light"
      style={{
        background: "linear-gradient(to right, #f8f9fa, #e9ecef)",
      }}
    >
      <div className="text-center p-4 shadow-lg rounded bg-white" style={{ maxWidth: "500px" }}>
        <h1 className="display-1 fw-bold text-danger">404</h1>
        <h2 className="mb-3">Oops! Page not found</h2>
        <p className="lead text-muted">
          The page you are looking for doesn't exist or might have been moved.
        </p>
        <Link to='/'>
        <button type='button'className='btn'>Back to Home</button>
        </Link>
      </div>
    </div>
  )
}

export default NotFound
